export enum DataGuide {
  STEP_836701_MICROTIP = 'step_836701_microtip',
  STEP_836701_HELP_ICON_TOOLTIP = 'step_836701_help_icon_tooltip',
  STEP_922045_ENTER_QUIET_SPACE = 'step_922045_enter_quiet_space',
  CONTACTS_LAUNCHPAD_CARDS = 'contacts_launchpad_cards',
  CONTACTS_TABLE = 'contacts_table',
  DOCUMENTS_ADD_DOCUMENT = 'documents_add_document',
  DOCUMENTS_ASSET_FOLDER = 'documents_asset_folder',
  FINANCIALS_OVERVIEW_TAB = 'financials_overview_tab',
  FINANCIALS_ASSETS_LIABILITIES_TABS = 'financials_assets_liabilities_tabs',
  FINANCIALS_CONNECTIONS_TAB = 'financials_connections_tab',
  FINANCIALS_DISTRIBUTION_TAB = 'financials_distribution_tab',
  MEETINGS_GUIDANCE_BLOCKS = 'meetings_guidance_blocks',
  MEETINGS_LEARN_MORE_BUTTON = 'meetings_learn_more_button',
  MEETINGS_INTAKE_TIMELINE = 'meetings_intake_timeline',
  PLAN_OVERVIEW_NAV_PANEL = 'plan_overview_nav_panel'
}
